// 全体の親
import ContractOrder from "@/pages/contractNeoOrder/Index";

// プラン選択画面
import ApplyPlan from '@/pages/contractNeoOrder/ApplyPlan'
// プラン変更確認画面
import ConfirmChangePlan from '@/pages/contractNeoOrder/ConfirmChangePlan'

// desknet's NEOサービス内容入力
import ContractNeoOrder from "@/pages/contractNeoOrder/ContractNeoOrder";
import ContractNeoConfirm from "@/pages/contractNeoOrder/ContractNeoConfirm";

// システムエラー
import SystemError from "@/pages/SystemError";

export default {
    path: "/contract_order",
    component: ContractOrder,
    children: [
        // プラン選択画面
        {
            path: "apply_plan",
            name: "ApplyPlan",
            component: ApplyPlan,
            meta: {
                currentPage: "ApplyPlan"
            },
            props: true
        },
        // プラン変更確認画面
        {
            path: 'confirm_change_plan',
            name: 'ConfirmChangePlan',
            component: ConfirmChangePlan,
            meta: {
                currentPage: 'ConfirmChangePlan'
            },
            props: true
        },
        {
            path: "contract_neo_order",
            name: "ContractNeoOrder",
            component: ContractNeoOrder,
            props: true
        },
        {
            path: "contract_neo_confirm",
            name: "ContractNeoConfirm",
            component: ContractNeoConfirm,
            props: true
        },
        {
            // システムエラー
            path: "system_error",
            name: "ContractNeoSystemError",
            component: SystemError,
            meta: {
                currentPage: ""
            },
            props: true,
        }
    ]
}